import * as paths from 'constants/paths';

const noBackButtonPaths = [
  paths.CHECKING_YOUR_IDENTITY,
  paths.CONFIRM_AUTH_CODE,
  paths.CONFIRM_CODE,
  paths.CONFIRM_JOINT_LINK_CODE,
  paths.CONGRATULATIONS,
  paths.CREDIT_CHECK_DECLINE,
  paths.CREDIT_CHECK_REFERRED,
  paths.CREDIT_CHECK_REFERRED_NO_MATCH,
  paths.CREDIT_CHECK_REFERRED_BANK_CHECK,
  paths.CREDIT_CHECK_REFERRED_BANK_CHECK_POI,
  paths.CREDIT_CHECK_REFERRED_POI,
  paths.DOCUMENT_RECEIVED,
  paths.DOCUMENTS_ON_WAY,
  paths.GET_IN_TOUCH,
  paths.ID_CHECK_CAN_NOT_DONE,
  paths.INELIGIBILTY_SCREEN,
  paths.JOINT_APPLICATION_SUBMISSION,
  paths.JOINT_INITIAL_QUESTION,
  paths.SUBMISSION_HOLDING_SCREEN,
  paths.VERIFYING_YOUR_IDENTITY,
  paths.YOUR_LOAN_APPROVAL,
  paths.DUPLICATE_CUSTOMER_ERROR,
  paths.WARNING_MESSAGE_SCREEN,
  paths.POST_DIP_REVIEW_DETAIL
];

export function isBackButtonHidden(path) {
  return noBackButtonPaths.includes(path);
}
